import { combineReducers } from 'redux';
import bidding from './bidding';
import trustedDevices from './trustedDevices';
export default combineReducers({
    bidding,
    trustedDevices,
});

export const getBiddingUserConfiguration = (state) => state.bidding;
export const getTrustedDeviceUserConfiguration = (state) => state.trustedDevices;
